import { Component } from '@angular/core';
import { UtilsTabsComponent } from '../../components/utils-tabs/utils-tabs.component';

@Component({
  selector: 'app-shipments',
  standalone: true,
  templateUrl: './shipments.component.html',
  imports: [UtilsTabsComponent],
  styleUrl: './shipments.component.scss'
})
export class ShipmentsComponent {}
